import { Link } from "react-router-dom";

export default function CheckoutCancel() {
  return (
    <div data-testid="checkout-cancel-page" className="pt-32 min-h-screen max-w-2xl mx-auto px-6 lg:px-12 text-center">
      <div className="overline">Checkout Cancelled</div>
      <h1 className="font-serif-editorial text-5xl lg:text-6xl mt-4 leading-tight">No charges<br /><em className="italic">were made.</em></h1>
      <p className="mt-6 text-[#5C5C5C]">Your cart is still curated. Return whenever you're ready.</p>
      <div className="mt-12 flex justify-center gap-4">
        <Link to="/shop" className="tt-btn-outline">Keep Browsing</Link>
      </div>
    </div>
  );
}
